/**
 * @generated SignedSource<<3656d3f8c85575d7a62e0a02f898e69b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type DepartmentType = "AQUATICS" | "AXE_THROWING" | "BASKETBALL" | "BOATING" | "BOCCE_BALL" | "BUSINESS" | "CARD_ROOM" | "CLUB" | "CROQUET" | "DINING" | "FITNESS" | "GOLF" | "HOCKEY" | "RACQUET" | "SALON" | "SHUFFLEBOARD" | "SPA";
import { FragmentRefs } from "relay-runtime";
export type departmentToScheduleOption_department$data = {
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly type: DepartmentType;
  readonly " $fragmentType": "departmentToScheduleOption_department";
};
export type departmentToScheduleOption_department$key = {
  readonly " $data"?: departmentToScheduleOption_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"departmentToScheduleOption_department">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "departmentToScheduleOption_department"
};

(node as any).hash = "625c0b4c2e93d2e0a8f01feb32ccbcb2";

export default node;
